import { render, staticRenderFns } from "./AddCollaborator.vue?vue&type=template&id=0477bb86&"
import script from "./AddCollaborator.vue?vue&type=script&lang=js&"
export * from "./AddCollaborator.vue?vue&type=script&lang=js&"
import style0 from "./AddCollaborator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports